//-- ******************* produccion  *******************
let urlDefault = `https://middlewarenew.nuvem.cloud/`;
let UrlSeguros = 'https://middlewarenew.nuvem.cloud/';
let UrlFinanciero = 'http://middlewarepruebasdesarrollo.us-west-2.elasticbeanstalk.com/' // poner url de produccion
let urlDefaultRetorno = 'https://plugin.nuvem.cloud/'
let UrlServicios = 'https://servicios.nuvem.cloud/api/';


export const UrlBase = urlDefault;
export const UrlBaseFinanciero = UrlFinanciero;

export const UrlImagenes = 'https://s3-us-west-2.amazonaws.com/middleware-images/';
export const urlSubirArchivo = 'https://s3-us-west-2.amazonaws.com/middleware-images/';
export const urlDocumentosPlugin = 'https://plugin-documentos.s3.us-west-2.amazonaws.com/';

export const URL_PLUGIN = `${UrlBase}backend/web/index.php?r=plugin/`;
export const URL_PLUGIN_FRONTEND = `${UrlBase}frontend/web/index.php?r=plugin/`;
export const URL_PLUGIN_PROD = `${UrlBase}backend/web/index.php?r=plugin/`; // talvez eliminar
export const URL_PLUGIN_SEGUROS = `${urlDefault}frontend/web/index.php?r=plugin/`;
export const URL_EDIT_VIGENCIA_COTIZACION = `${URL_PLUGIN}edit-vigencia-cotizacion`;
export const UrlBaseServicios = UrlServicios;

export const URL_RETORNO = process.env.REACT_APP_URL_RETORNO || urlDefaultRetorno;
